import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ChargeInterface } from "../../Entity/Entities/Charge/ChargeInterface";
import ChargeFactory from "../../Entity/Factories/ChargeFactory";

export default function* chargeChangeSent(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_CHANGE_SENT_REQUEST
    });

    const res = yield call(Http.patch, `charges/${action.payload?.chargeId}/send-status`, {
      ...action.payload
    });

    const charge: ChargeInterface = ChargeFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_CHARGE_CHANGE_SENT_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, charge);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CHARGE_CHANGE_SENT_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeChangeSent() {
  yield takeEvery(Constants.GLOBAL_CHARGE_CHANGE_SENT_START, chargeChangeSent);
}
